export const __DEV__ = process.env.NODE_ENV !== "production";

export const cx = (...classNames: Array<string | false | null | undefined>): string =>
    classNames.filter(Boolean).join(" ");
